import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";
import PropTypes from "prop-types";
// Styles
import {TooltipStyles as styles } from "./CustomTooltip.styles";

/**
 * Return a MUI Tooltip element with custom styles.
 * @param text { string } The text related with the tooltip definition.
 * @param color { string } Custom color (based on theme colors).
 * @returns {JSX.Element}
 */
function TooltipCustom({text, color='purple'}){

  return (
      <Tooltip componentsProps={styles} title={text} enterTouchDelay={0} enterDelay={0}>
        <InfoOutlinedIcon className="bubble-icon" fontSize={"small"} color={color}/>
      </Tooltip>
  )
}

TooltipCustom.propTypes ={
  text: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
  ]),
  color: PropTypes.string,
}

export default TooltipCustom
